import { UploadOutlined } from '@ant-design/icons'
import { useUpload } from '@web/react-common'
import { useRequest } from 'ahooks'
import { Button, Form, Input, Modal, Select, message } from 'antd'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { PpFile } from '@/schemas'

interface ProjectSummaryContainerProps {
  ppFile: PpFile
  canUpdate: boolean
  onFinish?: () => void
}

const CATEGORIES = ['PRD/需求文档', 'HLD/设计文档', '验收报告', '交付物', '其他']

export const PpFileEdit: React.FC<ProjectSummaryContainerProps> = ({ ppFile, canUpdate, onFinish }) => {
  const { t } = useTranslation()
  const { fileId, file, type: ppType, selfId: projectId } = ppFile
  const { category, url, title } = file
  const type = file.size ? 2 : 1

  const [visible, setVisible] = useState(false)
  // const [type, setType] = useState<number | null>(null)
  const [form] = Form.useForm()

  React.useEffect(() => {
    form.setFieldsValue({
      category,
      title,
      url,
      file,
    })
    setCurrentFile(file)
  }, [ppFile])

  const [currentFile, setCurrentFile] = useState<any>()

  const { run: updatePpFile } = useRequest(
    (data) => ({
      url: '/api/project/updatePpFile',
      method: 'post',
      data,
    }),
    {
      manual: true,
      onSuccess: () => {
        setVisible(false)
        form.resetFields()
        onFinish && onFinish()
      },
    }
  )

  const { run: uplaod } = useRequest(
    (data) => ({
      url: '/api/file/upload',
      method: 'post',
      data,
    }),
    {
      manual: true,
    }
  )

  const { uploadClickRef } = useUpload(
    {
      upload: async (file) => {
        setCurrentFile(file)
        return await uplaod(file)
      },
      onUploadStart(_file) {},
      onUploadProgress(_file) {},
      onUploadComplete(file) {
        if (file) {
          form.setFieldsValue({ file })
        }
      },
      onUploadError(_file) {},
      clickOptions: {
        accept: '*',
      },
    },
    []
  )

  const onOk = async () => {
    await form.validateFields().then((values) => {
      if (type === 2 && !values.file && !currentFile) {
        message.warning(t('upload error'))
        return
      }
      const params = {
        fileId,
        selfId: projectId,
        type: ppType,
        category: values.category,
        title: values.title,
        url: values.url,
      }
      if (type === 2) {
        params['url'] = values.file.url
        params['name'] = currentFile.name
        params['fileType'] = currentFile.type
        params['size'] = currentFile.size
        params['uuid'] = values.file.uuid
      }
      updatePpFile(params)
    })
  }

  // const clickMenu: MenuProps['onClick'] = ({ key, domEvent }) => {
  //   domEvent.stopPropagation()
  //   setType(Number(key))
  //   setVisible(true)
  // }

  const formDom = (
    <Form layout='vertical' form={form}>
      <Form.Item label={t('file category')} name='category' rules={[{ required: true }]}>
        <Select options={CATEGORIES.map((v) => ({ label: t(v), value: v }))} />
      </Form.Item>
      <Form.Item label={t('file title')} name='title' rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      {type === 1 && (
        <Form.Item label={t('file url')} name='url' rules={[{ required: true }]}>
          <Input />
        </Form.Item>
      )}
      {type === 2 && (
        <Form.Item label={t('upload file')} name='file' rules={[{ required: true }]}>
          <Button ref={uploadClickRef} icon={<UploadOutlined />}>
            {t('upload click')}
          </Button>
        </Form.Item>
      )}
    </Form>
  )

  return (
    <div className={'flex flex-col'}>
      <Button
        onClick={() => {
          setVisible(true)
        }}
        type='text'
        disabled={!canUpdate}
      >
        {t('edit')}
      </Button>
      <Modal
        forceRender
        title={t('edit') + ' - ' + (type === 1 ? t('add link') : t('add local'))}
        width='50vw'
        okText={t('save')}
        visible={visible}
        onOk={onOk}
        onCancel={() => setVisible(false)}
      >
        {formDom}
      </Modal>
    </div>
  )
}
